// extracted by mini-css-extract-plugin
export default {"Color":"Color_Color__R1Ub0","SelectedColor":"Color_SelectedColor__KLoOx"};